import React from "react";
import { Link } from "gatsby";
import Layout from "../../components/Layout";

const ToolsIndexPage = () => {
  return (
    <Layout>
      <section className="section">
        <div className="container">
          <div className="content">
            <h1 className="title is-1">Tools</h1>
            <p className="subtitle is-4">
              Curated tools and frameworks to help you optimize life, one insight at a time.
            </p>
            
            <div className="columns is-multiline">
              <div className="column is-12-tablet is-6-desktop">
                <div className="box tools-index-card">
                  <h3 className="title is-3 tools-index-card-title">
                    <Link to="/tools/inspidom" className="tools-index-card-link">Inspidom</Link>
                  </h3>
                  <p className="subtitle is-5 tools-index-card-description">
                    Inspiration + wisdom, one click at a time. Compressed thoughts to help you stay inspired and think wiser.
                  </p>
                  <div className="tools-index-card-actions">
                    <Link to="/tools/inspidom" className="button is-primary is-rounded tools-index-card-button">
                      Try Inspidom
                    </Link>
                    <Link to="/blog/inspidom/" className="button is-primary is-rounded tools-index-card-button">
                      Read the story
                    </Link>
                  </div>
                </div>
              </div>
              {/* Future tools can be added here */}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ToolsIndexPage;
